/* メイン画像下のキャプション：表示中スライド(.product__media-item.is-selected)の
   data-caption を同期する。スワイプ・サムネ・バリアント変更すべてに追従。

   .is-filtered（別カラーの画像）は Flickity の cellSelector 対象外でスライダー内に
   移動されず、is-selected が付いたまま DOM 上先頭に残ることがあるため必ず除外する。
   除外した結果 is-selected が無い場合は、Flickity が初期選択する先頭の表示対象に合わせる。 */
if (!customElements.get('product-media-caption')) {
  customElements.define(
    'product-media-caption',
    class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-media');
        if (!this.root) return;

        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.root, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });

        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      update() {
        const selected =
          this.root.querySelector('.product__media-item.is-selected:not(.is-filtered)') ||
          this.root.querySelector('.product__media-item:not(.is-filtered)');
        const text = selected ? (selected.getAttribute('data-caption') || '').trim() : '';

        if (text !== this.textContent.trim()) {
          this.textContent = text;
        }
      }
    }
  );
}
